import script from "./IntroductionAdmission.vue?vue&type=script&setup=true&lang=js"
export * from "./IntroductionAdmission.vue?vue&type=script&setup=true&lang=js"

import "./IntroductionAdmission.vue?vue&type=style&index=0&id=0d9079c7&lang=scss"

const __exports__ = script;

export default __exports__